/**
 * Get button values for a specific breakpoint
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import type { ResponsiveBreakpoint } from '../../../common';
import type { ButtonAttributes, ButtonValues } from '../../types';

/**
 * Get button values for a specific breakpoint
 */
export const getButtonValues = (
	attributes: ButtonAttributes,
	breakpoint: ResponsiveBreakpoint,
): ButtonValues => {
	return attributes[ breakpoint ] || {};
};
